import styled from "styled-components";

export const AppliancesPageStyle = styled.div`
    margin: 45px 128px 0px;
`;
